import { combineReducers } from 'redux'
import { collapse } from './setting';
import { projectInfo } from './projectInfo';
export default combineReducers({ collapse, projectInfo })